import React from 'react'
import RegisterPage from '../registerpage/RegisterPage'
import NavbarTop from '../NavbarTop'
import Footer from '../Footer'


function Register() {
  return (
    <div>
        <NavbarTop/>
      <RegisterPage/>
      <Footer />
    </div>
  )
}

export default Register
